import React from "react";

interface HistoryPaginationProps {
    page: number;
    pageCount: number;
    total: number;
    onPageChange: (page: number) => void;
    label: string;
    testId: string;
}

/** Пагинация под таблицами истории. Одна страница — навигация не нужна,
 *  поэтому компонент возвращает null, а не пустую панель. */
export function HistoryPagination({
    page,
    pageCount,
    total,
    onPageChange,
    label,
    testId,
}: HistoryPaginationProps): JSX.Element | null {
    if (pageCount <= 1) return null;

    return (
        <nav className="table-pagination" aria-label={label} data-testid={testId}>
            <button
                className="btn btn-ghost btn-sm"
                type="button"
                onClick={() => onPageChange(page - 1)}
                disabled={page === 0}
            >
                Назад
            </button>
            <span className="table-pagination-status" aria-live="polite">
                Страница {page + 1} из {pageCount} · Всего {total}
            </span>
            <button
                className="btn btn-ghost btn-sm"
                type="button"
                onClick={() => onPageChange(page + 1)}
                disabled={page + 1 >= pageCount}
            >
                Вперёд
            </button>
        </nav>
    );
}
